import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconFullscreen16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.37402 11.04L3.41406 14H6V16H0V10H2V12.5859L4.95996 9.62598L6.37402 11.04Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14 12.5859V10H16V16H10V14H12.5859L9.62598 11.04L11.04 9.62598L14 12.5859Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M6 2H3.41406L6.37402 4.95996L4.95996 6.37402L2 3.41406V6H0V0H6V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M16 6H14V3.41406L11.04 6.37402L9.62598 4.95996L12.5859 2H10V0H16V6Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFullscreen24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.70703 15.707L5.41406 20H8V22H2V16H4V18.5859L8.29297 14.293L9.70703 15.707Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M20 18.5859V16H22V22H16V20H18.5859L14.293 15.707L15.707 14.293L20 18.5859Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M8 4H5.41406L9.70703 8.29297L8.29297 9.70703L4 5.41406V8H2V2H8V4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M22 8H20V5.41406L15.707 9.70703L14.293 8.29297L18.5859 4H16V2H22V8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFullscreen48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.707 31.707L5.41406 44H15V46H2V33H4V42.5859L16.293 30.293L17.707 31.707Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M44 42.5859V33H46V46H33V44H42.5859L30.293 31.707L31.707 30.293L44 42.5859Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M15 4H5.41406L17.707 16.293L16.293 17.707L4 5.41406V15H2V2H15V4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M46 15H44V5.41406L31.707 17.707L30.293 16.293L42.5859 4H33V2H46V15Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
